/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_DECOSTITCH_APPLIED](state, payload) {
    state.decostitchApplied = payload;
  },
  [types.SET_UPGRADE_OPTIONS](state, { swatchId, status }) {
    state.upgradeOptions = {
      ...state.upgradeOptions,
      [swatchId]: { status }
    }
  },
  [types.SET_COMPONENT_DISABLED](state, {componentName, disabled}) {
    state.disabledComponents[componentName] = disabled;
  }
};

export default mutations;
